// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoSocial-styles__wrapper__1351dfe3","icon":"GalleryPhotoSocial-styles__icon__1351dfe3"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoSocial-styles.scss
// module id = 1049
// module chunks = 4 20 22 24